module.exports = __webpack_public_path__ + "static/media/concierge.9df24096.jpg";